/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from "react-intl";
import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { getAuth } from "../../../../../app/modules/auth";
import { useEffect, useState } from "react";
import axios from "axios";

async function getMenuItems() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiToken = getAuth();
  const token = apiToken?.api_token ?? "";

  const sidebarHeaders = {
    Authorization: `Bearer ${token}`,
  };

  return await axios
    .get(`${apiUrl}/sidebar-menu`, { headers: sidebarHeaders })
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return {
        companies: { companies: false },
        contracts: { templates: false, discounts: false },
        plans: { discountCoupons: false, plans: false },
        users: { users: false, permissions: false, roles: false },
      };
    });
}

const SidebarMenuMain = () => {
  const intl = useIntl();
  const [menuItems, setMenuItems] = useState({
    companies: { companies: false },
    contracts: { templates: false, discounts: false },
    plans: { discountCoupons: false, plans: false },
    users: { users: false, permissions: false, roles: false },
  });

  useEffect(() => {
    async function fetchMenuItems() {
      const items = await getMenuItems();
      setMenuItems(items);
    }

    fetchMenuItems();
  }, []);

  const showUsersMenu = Object.values(menuItems?.users).some(
    (value) => value === true,
  );
  const showPlansMenu = Object.values(menuItems?.plans).some(
    (value) => value === true,
  );
  const showCompaniesMenu = Object.values(menuItems?.companies).some(
    (value) => value === true,
  );
  const showContractsMenu = Object.values(menuItems?.contracts).some(
    (value) => value === true,
  );

  return (
    <div
      className="d-flex flex-column"
      style={{ minHeight: "calc(100vh - 120px)" }}
    >
      <div className="menu-top-section">
        <SidebarMenuItem
          to="/companies"
          icon="/media/icons/duotune/art/art002.svg"
          title={intl.formatMessage({ id: "MENU.DASHBOARD" })}
          fontIcon="bi-app-indicator"
        />
        <SidebarMenuItem
          to="/plan-upgrades"
          icon="/media/icons/duotune/arrows/arr056.svg"
          title="Upgrades de plano"
          fontIcon="bi-arrow-up-circle"
        />
      </div>

      <div className="mt-auto pb-10">
        <div className="menu-item">
          <div className="menu-content pt-8 pb-2">
            <span className="menu-section text-muted text-uppercase fs-8 ls-1">
              {intl.formatMessage({ id: "MENU.MODULES" })}
            </span>
          </div>
        </div>
        {/* {menuItems?.companies?.companies && (
          <SidebarMenuItem
            to="/companies"
            title={intl.formatMessage({
              id: "MENU.MODULE.MANAGER",
            })}
            hasBullet={true}
          />
        )} */}

        {showUsersMenu && (
          <SidebarMenuItemWithSub
            to="/change"
            title={intl.formatMessage({ id: "MENU.MODULE.MANAGEUSERS" })}
            icon="/media/icons/duotune/communication/com006.svg"
            fontIcon="bi-person"
          >
            {menuItems?.users?.users && (
              <SidebarMenuItem
                to="/users"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGEUSERS.USERS",
                })}
                hasBullet={true}
              />
            )}
            {menuItems?.users?.permissions && (
              <SidebarMenuItem
                to="/permissions"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGEUSERS.PERMISSIONS",
                })}
                hasBullet={true}
              />
            )}
            {menuItems?.users?.roles && (
              <SidebarMenuItem
                to="/roles"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGEUSERS.ROLES",
                })}
                hasBullet={true}
              />
            )}
          </SidebarMenuItemWithSub>
        )}

        {showPlansMenu && (
          <SidebarMenuItemWithSub
            to="/dashboard/planos"
            title={intl.formatMessage({ id: "MENU.MODULE.MANAGEPLANS" })}
            fontIcon="bi-archive"
            icon="/media/icons/duotune/general/gen017.svg"
          >
            {menuItems?.plans?.plans && (
              <SidebarMenuItem
                to="/plans"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGEPLANS.PLANS",
                })}
                hasBullet={true}
              />
            )}
            {/* {menuItems?.plans?.discountCoupons && (
              <SidebarMenuItem
                to="/discount-coupons"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGEPLANS.DISCOUNTCOUPONS",
                })}
                hasBullet={true}
              />
            )} */}
          </SidebarMenuItemWithSub>
        )}

        {/* {showCompaniesMenu && (
          <SidebarMenuItemWithSub
            to="/dashboard/companies"
            title={intl.formatMessage({ id: "MENU.MODULE.MANAGECOMPANIES" })}
            fontIcon="bi-archive"
            icon="/media/icons/duotune/general/gen022.svg"
          >
            {menuItems?.companies?.companies && (
              <SidebarMenuItem
                to="/companies"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGECOMPANIES.COMPANIES",
                })}
                hasBullet={true}
              />
            )}
          </SidebarMenuItemWithSub>
        )} */}

        {showContractsMenu && (
          <SidebarMenuItemWithSub
            to="/templates"
            title={intl.formatMessage({ id: "MENU.MODULE.MANAGECONTRACTS" })}
            fontIcon="bi-archive"
            icon="/media/icons/duotune/ecommerce/ecm009.svg"
          >
            {menuItems?.contracts?.templates && (
              <SidebarMenuItem
                to="/templates"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGECONTRACTS.MODELS",
                })}
                hasBullet={true}
              />
            )}
            {/* {menuItems?.contracts?.discounts && (
              <SidebarMenuItem
                to="/discounts"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGECONTRACTS.DISCOUNTS",
                })}
                hasBullet={true}
              />
            )} */}
          </SidebarMenuItemWithSub>
        )}
      </div>
    </div>
  );
};

export { SidebarMenuMain };
